import { useEffect, useState } from "react";

function parts(ms) {
  const total = Math.max(0, Math.floor(ms / 1000));
  return {
    d: Math.floor(total / 86400),
    h: Math.floor((total % 86400) / 3600),
    m: Math.floor((total % 3600) / 60),
    s: total % 60,
  };
}

/** Live countdown to an epoch (ms). Shows "Happening now" once the target passes. */
export default function Countdown({ target, endTarget, className = "" }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  if (!target) return null;
  const live = now >= target && (!endTarget || now < endTarget);
  if (live) {
    return (
      <div className={`inline-flex items-center gap-2 rounded-full bg-primary px-3.5 py-1.5 text-sm font-semibold text-primary-foreground ${className}`} data-testid="countdown-timer" data-live="1">
        <span className="relative flex h-2 w-2"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white opacity-75" /><span className="relative inline-flex h-2 w-2 rounded-full bg-white" /></span>
        Happening now — come on in
      </div>
    );
  }
  const p = parts(target - now);
  const cells = p.d > 0
    ? [[p.d, p.d === 1 ? "day" : "days"], [p.h, "hrs"], [p.m, "min"]]
    : [[p.h, "hrs"], [p.m, "min"], [p.s, "sec"]];
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="countdown-timer" aria-label="Countdown to the next Friday">
      {cells.map(([v, l], i) => (
        <div key={l} className="flex items-center gap-2">
          <div className="min-w-[3.25rem] rounded-xl border border-border bg-card px-2.5 py-1.5 text-center shadow-sm">
            <div className="font-display text-xl font-semibold tabular-nums leading-none text-foreground" data-testid={`countdown-${l}`}>{String(v).padStart(2, "0")}</div>
            <div className="mt-1 text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">{l}</div>
          </div>
          {i < cells.length - 1 && <span className="-mt-3 text-lg font-semibold text-muted-foreground/60">:</span>}
        </div>
      ))}
    </div>
  );
}
